import { Injectable } from '@angular/core';
import { PlatformType } from '../../../install/integrate/platform_type';
import { Volusion2Service } from './volusion2.service';

@Injectable()
export class PlatformService {

  constructor (private volusion2Service: Volusion2Service) {}

  navigate(platformId): void {
    if (this.isVolusion2Platform(platformId)) {
      this.volusion2Service.navigate();
    }
  }

  shouldAuthenticate(platform): boolean {
    return this.isVolusion2Platform(platform);
  }

  isVolusion2PlatformType(platform) {
    return platform === PlatformType.Volusion2;
  };

  shouldUseStrongPassword(platformId): boolean {
    return !this.isShopifyPlatform(platformId);
  };

  private isVolusion2Platform(platform): boolean {
    return platform === 32 || platform === 'volusion2';
  }

  private isShopifyPlatform(platformId): boolean {
    return platformId === 1;
  }
}
